// ===================================================
// calendarApi.js — 구글 캘린더 연동 API 모듈
//
// 역할:
//   - 일정 감지, 한 줄 질문 생성 → /api/ai-utils Edge Function
//   - 캘린더 추가/목록 → /api/calendar Edge Function
// ===================================================

import { getAuthToken } from './gptClient';

async function callEdge(url, body) {
  const token = await getAuthToken();
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || '요청 실패');
  }
  return res.json();
}

// ── 일정 감지: Edge Function에서 GPT 호출 ────
export async function detectSchedule(text) {
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  const WEEKDAYS = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
  const weekday = WEEKDAYS[today.getDay()];

  const { content } = await callEdge('/api/ai-utils', {
    action: 'detectSchedule',
    text, today: todayStr, weekday,
  });

  try {
    const jsonMatch = content.match(/\{[\s\S]*\}/);
    if (!jsonMatch) throw new Error('JSON 파싱 실패');
    return JSON.parse(jsonMatch[0]);
  } catch {
    return { type: 'plan', events: [] };
  }
}

// ── 단순 일정 후 한 줄 질문 생성 ────
export async function generateQuickQuestion(events) {
  const eventsText = events
    .map(e => `${e.title} (${e.date}${e.startTime ? ' ' + e.startTime : ''})`)
    .join(', ');

  const { content } = await callEdge('/api/ai-utils', {
    action: 'quickQuestion',
    eventsText,
  });
  return content;
}

// ── 구글 캘린더에 일정 추가 ────
export async function addToGoogleCalendar(events, googleAccessToken, calendarId) {
  return callEdge('/api/calendar', {
    action: 'add',
    googleAccessToken,
    calendarId: calendarId || 'primary',
    events,
  });
}

// ── 캘린더 목록 조회 ────
export async function listCalendars(googleAccessToken) {
  const data = await callEdge('/api/calendar', {
    action: 'list-calendars',
    googleAccessToken,
  });
  return data.calendars || [];
}
